import e from "react";
import { getIconColor as o } from "./iconfont.es5470.js";
import h from "./iconfont.es5471.js";
const i = {
  display: "block"
}, v = ({ size: t = 16, useVw: n, useRem: r, color: a, withColor: l, removeClassName: d, disableSSR: f, style: c, ...m }) => {
  const p = c ? { ...i, ...c } : i;
  return /* @__PURE__ */ e.createElement(h, { disableSSR: f }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "icon-12px-New-daohangtiao-fill", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 12 12", width: n ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (r ? "rem" : "px"), height: n ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (r ? "rem" : "px"), className: d ? "" : "iconpark-icon", style: p, fill: "none", ...m }, /* @__PURE__ */ e.createElement(
    "g",
    {
      clipPath: "url(#1258a4__a)"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 0a6 6 0 1 0 6 6V2a2 2 0 0 0-2-2H6Zm1.314 8.727h1.432l.004-5.454H7.497v.909h-.001v2.755A15.563 15.563 0 0 0 6.6 5.271L5.347 3.273H3.75v5.454h1.253V7.084c0-.887-.018-1.656-.053-2.377l.027-.008c.294.64.69 1.341 1.048 1.925l1.289 2.103Z",
        fill: l ? o(a, 0, "currentColor") : "currentColor",
        datafollowfill: l ? o(a, 0, "currentColor") : "currentColor"
      }
    )
  ), /* @__PURE__ */ e.createElement(
    "defs",
    null
  ), /* @__PURE__ */ e.createElement(
    "clipPath",
    {
      id: "1258a4__a"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M0 0h12v12H0z",
        fill: l ? o(a, 1, "#fff") : "#fff"
      }
    )
  )));
}, g = v;
export {
  g as default
};
